module.exports = __webpack_public_path__ + "static/media/20191130-steirische-lm-36.739755dd.jpg";